import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface FilterBarProps {
  globalFilter: string;
  onGlobalFilterChange: (value: string) => void;
  totalRows: number;
  filteredRows: number;
}

export default function FilterBar({
  globalFilter,
  onGlobalFilterChange,
  totalRows,
  filteredRows,
}: FilterBarProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="relative flex-1 max-w-md">
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={globalFilter}
          onChange={(e) => onGlobalFilterChange(e.target.value)}
          placeholder="Search all columns..."
          className="w-full pl-9 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-eep-navy/20 focus:border-eep-navy"
        />
      </div>
      <span className="text-xs text-gray-500">
        {filteredRows === totalRows
          ? `${totalRows} records`
          : `${filteredRows} of ${totalRows} records`}
      </span>
    </div>
  );
}
